import { connect }                             from 'react-redux'
import { ApplicationState, selectAccountType } from '../../redux/ducks/index'

const mstp = (state: ApplicationState) =>
  ({ accountType: selectAccountType(state) })

export type InjectedWithAccountTypeProps = ReturnType<typeof mstp>

export default connect(mstp)



// WEBPACK FOOTER //
// ./src/components/hocs/withAccountType.tsx